module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/137-fiji-0c192825d3730327b1437343841253a5.svg";